var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_391_2590",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_391_2590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 23H3C2.45 23 1.97917 22.8042 1.5875 22.4125C1.19583 22.0208 1 21.55 1 21V18H3V21H6V23ZM18 23V21H21V18H23V21C23 21.55 22.8042 22.0208 22.4125 22.4125C22.0208 22.8042 21.55 23 21 23H18ZM12 18.5C10 18.5 8.1875 17.9083 6.5625 16.725C4.9375 15.5417 3.75 13.9667 3 12C3.75 10.0333 4.9375 8.45833 6.5625 7.275C8.1875 6.09167 10 5.5 12 5.5C14 5.5 15.8125 6.09167 17.4375 7.275C19.0625 8.45833 20.25 10.0333 21 12C20.25 13.9667 19.0625 15.5417 17.4375 16.725C15.8125 17.9083 14 18.5 12 18.5ZM12 16.5C13.4667 16.5 14.8083 16.1 16.025 15.3C17.2417 14.5 18.175 13.4 18.825 12C18.175 10.6 17.2417 9.5 16.025 8.7C14.8083 7.9 13.4667 7.5 12 7.5C10.5333 7.5 9.19167 7.9 7.975 8.7C6.75833 9.5 5.825 10.6 5.175 12C5.825 13.4 6.75833 14.5 7.975 15.3C9.19167 16.1 10.5333 16.5 12 16.5ZM12 15.5C12.9667 15.5 13.7917 15.1583 14.475 14.475C15.1583 13.7917 15.5 12.9667 15.5 12C15.5 11.0333 15.1583 10.2083 14.475 9.525C13.7917 8.84167 12.9667 8.5 12 8.5C11.0333 8.5 10.2083 8.84167 9.525 9.525C8.84167 10.2083 8.5 11.0333 8.5 12C8.5 12.9667 8.84167 13.7917 9.525 14.475C10.2083 15.1583 11.0333 15.5 12 15.5ZM12 13.5C11.5833 13.5 11.2292 13.3542 10.9375 13.0625C10.6458 12.7708 10.5 12.4167 10.5 12C10.5 11.5833 10.6458 11.2292 10.9375 10.9375C11.2292 10.6458 11.5833 10.5 12 10.5C12.4167 10.5 12.7708 10.6458 13.0625 10.9375C13.3542 11.2292 13.5 11.5833 13.5 12C13.5 12.4167 13.3542 12.7708 13.0625 13.0625C12.7708 13.3542 12.4167 13.5 12 13.5ZM1 6V3C1 2.45 1.19583 1.97917 1.5875 1.5875C1.97917 1.19583 2.45 1 3 1H6V3H3V6H1ZM21 6V3H18V1H21C21.55 1 22.0208 1.19583 22.4125 1.5875C22.8042 1.97917 23 2.45 23 3V6H21Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrSidebarLogo);
export default __webpack_public_path__ + "static/media/ocr_sidebar_logo.294f9a34e9ecb8d550244eacdce8d6bd.svg";
export { ForwardRef as ReactComponent };